const addUniqueValue = (values, value) => {
  const trimmed = typeof value === 'string' ? value.trim() : '';
  if (!trimmed || values.includes(trimmed)) {
    return;
  }
  values.push(trimmed);
};

const collectContacts = (records = []) => {
  const emails = [];
  const phones = [];

  for (const record of records) {
    addUniqueValue(emails, record?.email);
    addUniqueValue(phones, record?.cellulare || record?.telefono);
  }

  return {
    emails,
    phones,
  };
};

export const buildAfContactDefaults = ({
  deleganti = [],
  clienti = [],
} = {}) => {
  const delegantiContacts = collectContacts(deleganti);
  const clientiContacts = collectContacts(clienti);

  const emails =
    delegantiContacts.emails.length > 0
      ? delegantiContacts.emails
      : clientiContacts.emails;
  const phones =
    delegantiContacts.phones.length > 0
      ? delegantiContacts.phones
      : clientiContacts.phones;

  return {
    email: emails.join(', '),
    whatsapp: phones.join(', '),
  };
};
